import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

const routes: Routes = [
];

if (environment.baseAsForm) {
  routes.push({ path: '', pathMatch: 'full', redirectTo: 'forms' });
  routes.push({ path: 'forms', loadChildren: () => import('./forms/forms-routing.module').then(m => m.DinggFormsRoutingModule), runGuardsAndResolvers: 'always',  });
  routes.push({ path: '**', redirectTo: '', pathMatch: 'full'});
} else {
  routes.push({ path: '', pathMatch: 'full', redirectTo: 'dashboard' });
  routes.push({ path: 'dashboard', loadChildren: () => import('./dashboard/dashboard-routing.module').then(m => m.DashboardRoutingModule), runGuardsAndResolvers: 'always',  });
  routes.push({ path: 'workspace', loadChildren: () => import('./design-workspace/design-workspace-routing.module').then(m => m.DesignWorkspaceRoutingModule), runGuardsAndResolvers: 'always',  });
  routes.push({ path: 'forms', loadChildren: () => import('./forms/forms-routing.module').then(m => m.DinggFormsRoutingModule), runGuardsAndResolvers: 'always',  });
  routes.push({ path: '**', redirectTo: '', pathMatch: 'full'});
}

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
